/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.0.3
* 
*******************************************************************************/
import indexOf from"./indexOf";import values from"./values";const contains=function(n,e){return null!==n&&(n.length!==+n.length&&(n=values(n)),indexOf(n,e)>=0)};export default contains;